import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { EguiData } from './purchase.state';

import { Adjustment, CartTax } from '@api/cart/cart.models';
import { PaymentMethod } from '@features/payment';
import { OrderPreview, PurchaseAttempt } from '@features/purchase-attempt';

/**
 * Definición de las acciones
 */
export const PurchaseActions = {
    LOAD_PURCHASE_ATTEMPT: '[purchase-attempt] LOAD_PURCHASE_ATTEMPT',
    LOAD_PURCHASE_ATTEMPT_SUCCESS: '[purchase-attempt] LOAD_PURCHASE_ATTEMPT_SUCCESS',
    LOAD_PURCHASE_ATTEMPT_ERROR: '[purchase-attempt] LOAD_PURCHASE_ATTEMPT_ERROR',
    LOAD_ORDER_PREVIEW: '[purchase-attempt] LOAD_ORDER_PREVIEW',
    LOAD_ORDER_PREVIEW_SUCCESS: '[purchase-attempt] LOAD_ORDER_PREVIEW_SUCCESS',
    LOAD_ORDER_PREVIEW_ERROR: '[purchase-attempt] LOAD_ORDER_PREVIEW_ERROR',

    LOAD_ASYNC_CHECKOUT: '[purchase] LOAD_ASYNC_CHECKOUT',
    LOAD_ASYNC_CHECKOUT_SUCCESS: '[purchase] LOAD_ASYNC_CHECKOUT_SUCCESS',
    LOAD_ASYNC_CHECKOUT_ERROR: '[purchase] LOAD_ASYNC_CHECKOUT_ERROR',
    CHECKOUT: '[purchase] CHECKOUT',
    CHECKOUT_SUCCESS: '[purchase] CHECKOUT_SUCCESS',
    CHECKOUT_ERROR: '[purchase] CHECKOUT_ERROR',

    LOAD_PROMO_CODE: '[purchase] LOAD_PROMO_CODE',
    LOAD_PROMO_CODE_SUCCESS: '[purchase] LOAD_PROMO_CODE_SUCCESS',
    LOAD_PROMO_CODE_ERROR: '[purchase] LOAD_PROMO_CODE_ERROR',
    DELETE_PROMO_CODE: '[purchase] DELETE_PROMO_CODE',
    DELETE_PROMO_CODE_SUCCESS: '[purchase] DELETE_PROMO_CODE_SUCCESS',
    DELETE_PROMO_CODE_ERROR: '[purchase] DELETE_PROMO_CODE_ERROR',
    SET_VALIDATION_CHECK_VALUE: '[purchase] SET_VALIDATION_CHECK_VALUE',
    SET_BILLING_IS_NEEDED: '[purchase] SET_BILLING_IS_NEEDED',
    RESET_CHECKOUT_ERRORS: '[purchase] RESET_CHECKOUT_ERRORS',
    SET_SYNC_CHECKOUT_LAUNCHED: '[purchase] SET_SYNC_CHECKOUT_LAUNCHED',
    SET_CARDINAL_DDC: '[purchase] SET_CARDINAL_DDC',
    SET_EGUI_DATA: '[summary] SET_EGUI_DATA',
    SET_PURCHASE_ATTEMPT_SHIPPING_COSTS: '[purchase] SET_PURCHASE_ATTEMPT_SHIPPING_COSTS',
};

export const SetEguiData = createAction(
    PurchaseActions.SET_EGUI_DATA,
    props<{ eguiData: EguiData }>(),
);
export const LoadPurchaseAttempt = createAction(PurchaseActions.LOAD_PURCHASE_ATTEMPT, props<{ cartId: number }>());
export const LoadPurchaseAttemptSuccess = createAction(
    PurchaseActions.LOAD_PURCHASE_ATTEMPT_SUCCESS,
    props<{ values: PurchaseAttempt }>(),
);
export const LoadPurchaseAttemptError = createAction(PurchaseActions.LOAD_PURCHASE_ATTEMPT_ERROR, props<{ error: any }>());
export const LoadOrderPreview = createAction(PurchaseActions.LOAD_ORDER_PREVIEW);
export const LoadOrderPreviewSuccess = createAction(
    PurchaseActions.LOAD_ORDER_PREVIEW_SUCCESS,
    props<{ orderPreview: OrderPreview }>(),
);
export const LoadOrderPreviewError = createAction(PurchaseActions.LOAD_ORDER_PREVIEW_ERROR, props<{ error: any }>());
export const LoadAsyncCheckout = createAction(PurchaseActions.LOAD_ASYNC_CHECKOUT);
export const LoadAsyncCheckoutSuccess = createAction(
    PurchaseActions.LOAD_ASYNC_CHECKOUT_SUCCESS,
    props<{ orderId: string }>(),
);
export const LoadAsyncCheckoutError = createAction(
    PurchaseActions.LOAD_ASYNC_CHECKOUT_ERROR,
    props<{ error: any; selectedPayment?: PaymentMethod }>(),
);
export const Checkout = createAction(
    PurchaseActions.CHECKOUT,
    props<{ orderId: string }>(),
);
export const CheckoutSuccess = createAction(PurchaseActions.CHECKOUT_SUCCESS);
export const CheckoutError = createAction(PurchaseActions.CHECKOUT_ERROR, props<{ error: any }>());
export const LoadPromoCode = createAction(PurchaseActions.LOAD_PROMO_CODE, props<{ promocode: string }>());
export const LoadPromoCodeSuccess = createAction(PurchaseActions.LOAD_PROMO_CODE_SUCCESS, props<{ promoCode: string }>());
export const LoadPromoCodeError = createAction(
    PurchaseActions.LOAD_PROMO_CODE_ERROR,
    props<{ error: HttpErrorResponse; promoCode: string }>(),
);
export const DeletePromoCode = createAction(PurchaseActions.DELETE_PROMO_CODE, props<{ promocode: string }>());
export const DeletePromoCodeSuccess = createAction(
    PurchaseActions.DELETE_PROMO_CODE_SUCCESS,
    props<{ promoCode: string }>(),
);
export const DeletePromoCodeError = createAction(
    PurchaseActions.DELETE_PROMO_CODE_ERROR,
    props<{ error: any; promoCode: string }>(),
);
export const SetValidationCheckValue = createAction(
    PurchaseActions.SET_VALIDATION_CHECK_VALUE,
    props<{ values: Record<string, boolean> }>(),
);
export const SetCardinalDdc = createAction(PurchaseActions.SET_CARDINAL_DDC, props<{ ddc: string }>());
export const SetBillingIsNeeded = createAction(
    PurchaseActions.SET_BILLING_IS_NEEDED,
    props<{ isNeeded: boolean; vatin?: string }>(),
);
export const ResetCheckoutErrors = createAction(PurchaseActions.RESET_CHECKOUT_ERRORS);
export const SetSyncCheckoutLaunched = createAction(PurchaseActions.SET_SYNC_CHECKOUT_LAUNCHED);

export const SetPurchaseAttemptShippingCosts = createAction(
    PurchaseActions.SET_PURCHASE_ATTEMPT_SHIPPING_COSTS,
    props<{
        adjustment: Adjustment[];
        shippingPrice: number;
        shippingTax: number;
        totalOrder: number;
        taxArray: CartTax[];
        tax: number;
    }>(),
);
